// see public/env.js file (or public/env.example.js)
console.info("window.___APP_CONFIG___", window.___APP_CONFIG___);

export function getConfig() {
  if (!window.___APP_CONFIG___) console.error("Provide window.___APP_CONFIG___");
  return window.___APP_CONFIG___;
}
